import {API_ROOT_URL} from 'envs/_current/config'
import {createAsyncAction} from 'modules/asyncCache'
import {normalize, schema} from 'normalizr'
import {baseFieldTypes} from './base/baseFieldTypes'
import {
    channelSchema,
    feedSchema,
    organizationAnnouncementSchema,
    organizationDepartmentMemberSchema,
    organizationDepartmentSchema,
    organizationSchema,
    userSchema,
} from './schema'
import {commentSchema} from './schema/commentSchema'
import {eventSchema} from './schema/event'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'


const auth_organization_schema = new schema.Entity(
    'organizations',
    {
        auth_user: userSchema,
    },
    {
        idAttribute: 'idname',
    }
)

const auth_organization_transform = (response, {query}) => {
    const {entities, result} = normalize(
        response.data,
        auth_organization_schema
    )
    if (Number(response?.status) !== 200) {
        return {
            error: true,
            errorMessages: response?.data,
        }
    } else {
        return {
            response,
            entities,
            result,
        }
    }
}

const fields = [
    'idname', // unique ~ username
    'user_id', // auto fill by login user
    'owner_id', // auto fill by login user
    'owner_type', // auto fill by login user
    'org_type', // 100: company
    'title', // Ten cong ty
    'description', // mo ta cong ty
    'avatar', // avatar
    'thumbnail', // tu gen ra boi avatar (kich thuoc nho hon)
    'cover_photo', // banner
    'status', // auto fill = 1
    'certified', // auto fill = 0
    'privacy', // 1: public, 2: private
    'public', // 1: search allow, 0: no searchable -> Kristo control
    'active', // 1: active (default), 0: inactive -> user control,
    'categories',
    'about', // rich text
]

const organization_FieldTypes = {
    user_id: baseFieldTypes.auto,
    owner_id: baseFieldTypes.auto,
    avatar: baseFieldTypes.image,
    cover_photo: baseFieldTypes.image,
    thumbnail: baseFieldTypes.auto,
    about: baseFieldTypes.string,
    // status: baseFieldTypes.status,
    // active: baseFieldTypes.active,
    // certified: baseFieldTypes.certified,
    // privacy: baseFieldTypes.privacy,
    // public: baseFieldTypes.public
}

const followSchema = new schema.Union(
    {
        organization: organizationSchema,
        organization_department: organizationDepartmentSchema,
        channel: channelSchema,
        user: userSchema,
    },
    '_type'
)

// Route::post('organizations/add', 'OrganizationController@store');
export const organization_Create_Api = {
    backend: `Route::post('organizations/add', 'OrganizationController@store')`,
    root: API_ROOT_URL,
    path: '/organizations/add',
    method: 'POST',
    fields,
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    // schema: auth_organization_schema,
    transform: auth_organization_transform,
}

// Route::post('organizations/{id}/edit', 'OrganizationController@update');
export const organization_Edit_Api = {
    backend: `Route::post(''organizations/{id}/edit'', 'OrganizationController@update')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/edit',
    method: 'POST',
    fields,
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    // schema: auth_organization_schema,
    transform: auth_organization_transform,
}
// Route::post('organizations/{id}/delete', 'OrganizationController@deletePollQuestion');
export const organization_Delete_Api = {
    backend: `Route::post(''organizations/{id}/delete'', 'OrganizationController@deletePollQuestion')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/delete',
    method: 'POST',
    fields,
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    // schema: auth_organization_schema,
    transform: auth_organization_transform,
}

// Route::get('organizations/get-typical-organizations', 'OrganizationController@getTypicalOrganizations');
export const organization_GetTypicalOrganizations_Api = {
    backend: `Route::get('organizations/get-typical-organizations', 'OrganizationController@getTypicalOrganizations')`,
    root: API_ROOT_URL,
    path: '/organizations/get-typical-organizations',
    method: 'GET',
    fieldTypes: organization_FieldTypes,
    transform: createListTransform(organizationSchema),
}

// Route::get('organizations/{id}/get-following-users', 'OrganizationController@getFollowingUsers');
export const organization_GetFollowingUsers_Api = {
    backend: `Route::get('organizations/{id}/get-following-users', 'OrganizationController@getFollowingUsers')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get-following-users',
    method: 'GET',
    fieldTypes: organization_FieldTypes,
    transform: createListTransform(organizationSchema),
}

export const organization_getOrganizationsByAuth_Api = {
    backend: `Route::get('organizations/organization/get-items-by-auth', 'OrganizationController@getOrganizationsByAuth');`,
    root: API_ROOT_URL,
    path: '/organizations/organization/get-items-by-auth',
    method: 'GET',
    paramsFields: ['organization_id'],
    fieldTypes: organization_FieldTypes,
    transform: createListTransform(organizationSchema),
}

// Route::get('organizations/{id}/validate-sub-domain', 'OrganizationController@validateSubDomain');
export const organization_validateSubDomain_Api = {
    backend: `Route::get('organizations/{id}/validate-sub-domain', 'OrganizationController@validateSubDomain')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/validate-sub-domain',
    method: 'GET',
    transform: createTransform(organizationSchema, 'data'),
}

// Route::get('organizations/{id}/get', 'OrganizationController@getById');
export const organization_getById_Api = {
    backend: `Route::get('organizations/:id/get', 'OrganizationController@getById')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get',
    method: 'GET',
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}
export const create_organization_getById_Api_action =
    () =>
        ({prefixStr = 'organization_getById_Api', query, values, maxAge =
            -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@organization_getById_Api',
                query,
                values,
                apiInfo: organization_getById_Api,
                maxAge,
            })
// Route::get('organizations/{id}/show', 'OrganizationController@show');
export const organization_show_Api = {
    backend: `Route::get('organizations/{id}/show', 'OrganizationController@show')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/show',
    method: 'GET',
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}

// Route::post('organizations/{id}/request-verify', 'OrganizationController@requestVerifyTaxCode');
export const organization_RequestVerify_Api = {
    backend: `Route::post('organizations/{id}/request-verify', 'OrganizationController@requestVerifyTaxCode');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/request-verify',
    method: 'POST',
    fields,
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}

export const organization_ExportPurchasePriceData_Api = {
    backend: `Route::post('exports/organization/{id}/export-purchasing-price-data', 'ProductPriceController@exportPurchasePriceData')`,
    root: API_ROOT_URL,
    path: '/exports/organization/:id/export-purchasing-price-data',
    method: 'POST',
    fields,
    fieldTypes: organization_FieldTypes,
}

export const organization_ExportPriceData_Api = {
    backend: `Route::post('exports/organization/{id}/export-price-data', 'ProductPriceController@exportPriceData')`,
    root: API_ROOT_URL,
    path: '/exports/organization/:id/export-price-data',
    method: 'POST',
    fields,
    fieldTypes: organization_FieldTypes,
}

export const organization_fetchLatestFeeds_Api = {
    backend: `Route::get('organizations/{id}/insights/get-latest-feeds', 'OrganizationInsightsController@fetchLatestFeeds'); // content_type: article,ask,post,repost,poll_question`,
    root: API_ROOT_URL,
    path: '/organizations/:id/insights/get-latest-feeds',
    method: 'GET',
    paramsFields: ['content_type'],
    schema: feedSchema,
    transform: createListTransform(feedSchema),
}

export const organization_getOrganizationsByUser_Api = {
    backend: `Route::get('organizations/user/{id}/gets', 'OrganizationController@getOrganizationsByUser');`,
    root: API_ROOT_URL,
    path: '/organizations/user/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'role'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchLatestFollowers_Api = {
    backend: `Route::get('organizations/{id}/insights/get-latest-followers', 'OrganizationInsightsController@fetchLatestFollowers');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/insights/get-latest-followers',
    method: 'GET',
    schema: followSchema,
    transform: createListTransform(followSchema),
}

export const organization_fetchLatestComments_Api = {
    backend: `Route::get('organizations/{id}/insights/get-latest-comments', 'OrganizationInsightsController@fetchLatestComments');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/insights/get-latest-comments',
    method: 'GET',
    schema: commentSchema,
    transform: createListTransform(commentSchema),
}

export const organization_fetchStatistics_Api = {
    backend: `Route::get('organizations/{id}/insights/get-statistics', 'OrganizationInsightsController@fetchStatistics');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/insights/get-statistics',
    method: 'GET',
    paramsFields: ['period'],
}

export const organization_getEventsByHost_Api = {
    backend: `Route::get('organization/{organization_id}/hosts/get-event-by-host', 'OrganizationHostsController@getEventsByHost');`,
    root: API_ROOT_URL,
    path: '/organization/:organization_id/hosts/get-event-by-host',
    method: 'GET',
    paramsFields: ['status', 'sort_by', 'keyword', 'organization_id'],
    schema: eventSchema,
    transform: createListTransform(eventSchema),
}

export const organization_getOrgMembersSiteMaps_Api = {
    backend: `API: Route::get('organization/{organization_id}/hosts/get-site-map', 'OrganizationHostsController@getOrgMembersSiteMaps');`,
    root: API_ROOT_URL,
    path: '/organization/:organization_id/hosts/get-site-map',
    method: 'GET',
}


export const organization_getOrganizationsByParishAssocRequest_Api = {
    backend: `Route::get('organizations/parish/association-request', 'OrganizationController@getOrganizationsByParishAssocRequest');`,
    root: API_ROOT_URL,
    path: '/organizations/parish/association-request',
    method: 'GET',
    paramsFields: ['keyword', 'status'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}
export const organization_getOrganizationsByDioceseAssocRequest_Api = {
    backend: `Route::get('organizations/diocese/association-request', 'OrganizationController@getOrganizationsByDioceseAssocRequest');`,
    root: API_ROOT_URL,
    path: '/organizations/diocese/association-request',
    method: 'GET',
    paramsFields: ['keyword', 'status'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}
export const organization_getOrganizationsByReligiousOrderAssocRequest_Api = {
    backend: `Route::get('organizations/religious-order/association-request', 'OrganizationController@getOrganizationsByReligiousOrderAssocRequest');`,
    root: API_ROOT_URL,
    path: '/organizations/religious-order/association-request',
    method: 'GET',
    paramsFields: ['keyword', 'status'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

// Route::post('organizations/{id}/change-assoc-status', 'OrganizationController@updateOrganizationsAssocStatus');
export const organization_updateOrganizationsAssocStatus_Api = {
    backend: `Route::post('organizations/{id}/change-assoc-status', 'OrganizationController@updateOrganizationsAssocStatus');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/change-assoc-status',
    method: 'POST',
    fields,
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}

export const user_fetchSuggestionOrganizationAppChoices_Api = {
    name: 'user_fetchSuggestionOrganizationAppChoices_Api',
    backend: `Route::get('recommendations/organization/suggested-items', 'PromoteController@getOrganizations');`,
    root: API_ROOT_URL,
    path: '/recommendations/organization/suggested-items',
    method: 'GET',
    paramsFields: ['category_id'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchItems_Api = {
    name: 'organization_fetchItems_Api',
    backend: `Route::get('organizations/fetch-items', 'OrganizationController@fetchItems');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-items',
    method: 'GET',
    paramsFields: ['keyword', 'country_id', 'org_type', 'parish_id', 'diocese_id'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchGlobalOrganizations = {
    name: 'organization_fetchGlobalOrganizations',
    backend: `Route::get('organizations/fetch-global-items', 'OrganizationController@fetchGlobalOrganizations');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-global-items',
    method: 'GET',
    paramsFields: [],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_getAnnouncementById_Api = {
    name: 'organization_getAnnouncementById_Api',
    backend: `Route::get('organizations/organization-announcement/{id}/get', 'OrganizationAnnouncementController@getById');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-announcement/:id/get',
    method: 'GET',
    schema: organizationAnnouncementSchema,
    transform: createTransform(organizationAnnouncementSchema),
}

export const organization_getAnnouncements_Api = {
    name: 'organization_getAnnouncements_Api',
    backend: `Route::get('organizations/{id}/get-announcements', 'OrganizationAnnouncementController@getAnnouncements');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get-announcements',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: organizationAnnouncementSchema,
    transform: createListTransform(organizationAnnouncementSchema),
}

export const organization_createAnnouncement_Api = {
    name: 'organization_createAnnouncement_Api',
    backend: `Route::post('organizations/{id}/create-announcement', 'OrganizationAnnouncementController@createAnnouncement');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/create-announcement',
    method: 'POST',
    schema: organizationAnnouncementSchema,
    transform: createTransform(organizationAnnouncementSchema, 'data'),
}

export const organization_deleteAnnouncement_Api = {
    name: 'organization_deleteAnnouncement_Api',
    backend: `Route::post('organizations/organization-announcement/{id}/delete', 'OrganizationAnnouncementController@deleteAnnouncement');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-announcement/:id/delete',
    method: 'POST',
    schema: organizationAnnouncementSchema,
    transform: createTransform(organizationAnnouncementSchema, 'data'),
}

export const organization_updateAnnouncement_Api = {
    name: 'organization_updateAnnouncement_Api',
    backend: `Route::post('organizations/organization-announcement/{id}/edit', 'OrganizationAnnouncementController@updateAnnouncement');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-announcement/:id/edit',
    method: 'POST',
    schema: organizationAnnouncementSchema,
    transform: createTransform(organizationAnnouncementSchema, 'data'),
}

export const notification_getMyOrganizationAnnouncements_Api = {
    backend: `Route::get('notifications/{type}/get-announcements', 'NotificationController@getMyAnnouncements');`,
    root: API_ROOT_URL,
    path: '/notifications/organization/get-announcements',
    method: 'GET',
    schema: organizationAnnouncementSchema,
    transform: createListTransform(organizationAnnouncementSchema),
}


//=========  Department


export const organization_getDepartments_Api = {
    name: 'organization_getDepartments_Api',
    backend: `Route::get('organizations/{id}/get-departments', 'OrganizationDepartmentController@getDepartments');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get-departments',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'group_nbr'],
    schema: organizationDepartmentSchema,
    transform: createListTransform(organizationDepartmentSchema),
}

export const organization_createDepartment_Api = {
    name: 'organization_createDepartment_Api',
    backend: `Route::post('organizations/{id}/create-department', 'OrganizationDepartmentController@createDepartment');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/create-department',
    method: 'POST',
    schema: organizationDepartmentSchema,
    transform: createTransform(organizationDepartmentSchema, 'data'),
}

export const organization_deleteDepartment_Api = {
    name: 'organization_deleteDepartment_Api',
    backend: `Route::post('organizations/organization-department/{id}/delete', 'OrganizationDepartmentController@deleteDepartment');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department/:id/delete',
    method: 'POST',
    schema: organizationDepartmentSchema,
    transform: createTransform(organizationDepartmentSchema, 'data'),
}

export const organization_updateDepartment_Api = {
    name: 'organization_updateDepartment_Api',
    backend: `Route::post('organizations/organization-department/{id}/edit', 'OrganizationDepartmentController@updateDepartment');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department/:id/edit',
    method: 'POST',
    schema: organizationDepartmentSchema,
    transform: createTransform(organizationDepartmentSchema, 'data'),
}

export const organization_department_getById_Api = {
    backend: `Route::get('organizations/organization-department/{id}/get', 'OrganizationDepartmentController@getDepartmentById');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department/:id/get',
    method: 'GET',
    schema: organizationDepartmentSchema,
    transform: createTransform(organizationDepartmentSchema, 'data'),
}


export const organization_department_getDepartmentMembers_Api = {
    backend: `Route::get('organizations/organization-department/{id}/get-members', 'OrganizationDepartmentController@getDepartmentMembers');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department/:id/get-members',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: organizationDepartmentMemberSchema,
    transform: createListTransform(organizationDepartmentMemberSchema),
}


export const organization_department_addMember_Api = {
    name: 'organization_department_addMember_Api',
    backend: `Route::post('organizations/organization-department/{id}/add-member', 'OrganizationDepartmentController@addMember');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department/:id/add-member',
    method: 'POST',
    schema: organizationDepartmentMemberSchema,
    transform: createTransform(organizationDepartmentMemberSchema, 'data'),
}

export const organization_department_editMember_Api = {
    name: 'organization_department_editMember_Api',
    backend: `Route::post('organizations/organization-department-member/{id}/edit-member', 'OrganizationDepartmentController@editMember');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department-member/:id/edit-member',
    method: 'POST',
    schema: organizationDepartmentMemberSchema,
    transform: createTransform(organizationDepartmentMemberSchema, 'data'),
}

export const organization_department_updateMemberInfo_Api = {
    name: 'organization_department_updateMemberInfo_Api',
    backend: `Route::post('organizations/organization-department-member/{id}/update-member-info', 'OrganizationDepartmentController@updateMemberInfo');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department-member/:id/update-member-info',
    method: 'POST',
    schema: organizationDepartmentMemberSchema,
    transform: createTransform(organizationDepartmentMemberSchema, 'data'),
}

export const organization_department_removeMember_Api = {
    name: 'organization_department_removeMember_Api',
    backend: `Route::post('organizations/organization-department-member/{id}/remove-member', 'OrganizationDepartmentController@removeMember');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department-member/:id/remove-member',
    method: 'POST',
    schema: organizationDepartmentMemberSchema,
    transform: createTransform(organizationDepartmentMemberSchema, 'data'),
}

export const organization_department_setMemberActive_Api = {
    name: 'organization_department_setMemberActive_Api',
    backend: `Route::post('organizations/organization-department-member/{id}/set-active', 'OrganizationDepartmentController@setMemberActive');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department-member/:id/set-active',
    method: 'POST',
    schema: organizationDepartmentMemberSchema,
    transform: createTransform(organizationDepartmentMemberSchema, 'data'),
}


// ===================================== courseClassTimetableSchema =====================================
export const organizationTimetableSchema = new schema.Entity(
    'organization_timetable',
    {},
    {
        idAttribute: 'id',
    }
)
export const organizationTimetableDetailSchema = new schema.Entity(
    'organization_timetable_detail',
    {},
    {
        idAttribute: 'id',
    }
)

export const organization_createTimetable_Api = {
    name: 'organization_createTimetable_Api',
    backend: `Route::post('organizations/{id}/timetable/create', 'OrganizationTimetableController@createTimetable');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/timetable/create',
    method: 'POST',
    schema: organizationTimetableSchema,
    transform: createTransform(organizationTimetableSchema, 'data'),
}
export const organization_updateTimetable_Api = {
    name: 'organization_updateTimetable_Api',
    backend: `Route::post('organizations/organization-timetable/{id}/edit', 'OrganizationTimetableController@updateTimetable');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-timetable/:id/edit',
    method: 'POST',
    schema: organizationTimetableSchema,
    transform: createTransform(organizationTimetableSchema, 'data'),
}
export const organization_deleteTimetable_Api = {
    name: 'organization_deleteTimetable_Api',
    backend: `Route::post('organizations/organization-timetable/{id}/delete', 'OrganizationTimetableController@deleteTimetable');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-timetable/:id/delete',
    method: 'POST',
    schema: organizationTimetableSchema,
    transform: createTransform(organizationTimetableSchema, 'data'),
}

export const organization_getOrganizationTimetables_Api = {
    name: 'organization_getOrganizationTimetables_Api',
    backend: `Route::get('organizations/{id}/organization-timetable/gets', 'OrganizationTimetableController@getOrganizationTimetables');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/organization-timetable/gets',
    method: 'GET',
    paramsFields: [
        'keyword',
        'status',
        'course_id',
        'subject_id',
        'course_class_id',
        'to_time_open',
        'from_time_open',
    ],
    schema: organizationTimetableSchema,
    transform: createListTransform(organizationTimetableSchema),
}

export const organization_getOrganizationTimetableMilestones_Api = {
    name: 'organization_getOrganizationTimetableMilestones_Api',
    backend: `Route::get('organizations/organization-department/{id}/get-timetables', 'OrganizationTimetableController@getOrganizationTimetableMilestones');`,
    root: API_ROOT_URL,
    path: '/organizations/organization-department/:id/get-timetables',
    method: 'GET',
    paramsFields: [
        'keyword',
        'status',
        'organization_department_assessment_id',
        'organization_department_id',
        'organization_id',
        'to_time_open',
        'from_time_open',
    ],
    schema: organizationTimetableSchema,
    transform: createListTransform(organizationTimetableSchema),
}


export const organization_getOrganizationTimetableDetails_Api = {
    name: 'organization_getOrganizationTimetableDetails_Api',
    backend: `Route::get('organizations/{id}/get-timetable-details', 'OrganizationTimetableController@getOrganizationTimetableDetails');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get-timetable-details',
    method: 'GET',
    paramsFields: [
        'keyword',
        'organization_department_id',
        'organization_timetable_detail_id'
    ],
    schema: organizationTimetableDetailSchema,
    transform: createListTransform(organizationTimetableDetailSchema),
}
export const organization_getTimetableDetailsByMember_Api = {
    name: 'organization_getTimetableDetailsByMember_Api',
    backend: `Route::get('organizations/member/{member_id}/timetable/gets', 'OrganizationTimetableController@getTimetableDetailsByMember');`,
    root: API_ROOT_URL,
    path: '/organizations/member/:id/timetable/gets',
    method: 'GET',
    paramsFields: [
        'keyword',
        'organization_department_id',
        'organization_timetable_detail_id'
    ],
    schema: organizationTimetableDetailSchema,
    transform: createListTransform(organizationTimetableDetailSchema),
}


export const platformStatisticSchema = new schema.Entity(
    'platform_statistics',
    {},
    {
        idAttribute: 'id',
    }
)

export const apps_getPlatformStatistics_Api = {
    name: 'apps_getPlatformStatistics_Api',
    backend: `Route::get('apps/get-platform-statistics', 'AppStatisticController@getPlatformStatistics');`,
    root: API_ROOT_URL,
    path: '/apps/get-platform-statistics',
    method: 'GET',
    schema: platformStatisticSchema,
    transform: createTransform(platformStatisticSchema, 'data'),
}


export const organization_fetchItemsBySysAdmin_Api = {
    name: 'organization_fetchItemsBySysAdmin_Api',
    backend: `Route::get('organizations/fetch-items-by-sysadmin', 'OrganizationController@fetchItemsBySysAdmin');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-items-by-sysadmin',
    method: 'GET',
    paramsFields: ['keyword', 'highlighted', 'org_type', 'privacy'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchLatestItemsBySysAdmin_Api = {
    name: 'organization_fetchLatestItemsBySysAdmin_Api',
    backend: `Route::get('organizations/fetch-latest-items-by-sysadmin', 'OrganizationController@fetchLatestItemsBySysAdmin');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-latest-items-by-sysadmin',
    method: 'GET',
    paramsFields: ['keyword', 'highlighted', 'org_type', 'privacy'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchWaitingItemsBySysAdmin_Api = {
    name: 'organization_fetchWaitingItemsBySysAdmin_Api',
    backend: `Route::get('organizations/fetch-waiting-items-by-sysadmin', 'OrganizationController@fetchWaitingItemsBySysAdmin');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-waiting-items-by-sysadmin',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}